/**
 * PortalNewsSection.js
 * ════════════════════════════════════════════════════════════════
 * Повна секція новин порталу на головній сторінці — заголовок +
 * NewsPublic (фільтр категорій, сітка карток, "показати ще").
 *
 * На відміну від InvitationSection (карусель останніх 5),
 * ця секція показує ВСІ опубліковані новини порталу з пагінацією.
 * ════════════════════════════════════════════════════════════════
 */

import React, { useState, useEffect } from 'react';
import NewsPublic from '../kindergartens/detail/components/News/NewsPublic';
import { newsAPI } from '../kindergartens/detail/components/News/newsAPI';

// Скоригуй шлях до News/ залежно від того, куди винесеш папку

const PortalNewsSection = () => {
  const [hasNews, setHasNews] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    newsAPI.getPublicList('portal', null, { limit: 1 })
      .then((result) => setHasNews((result.total || 0) > 0))
      .catch(() => setHasNews(false))
      .finally(() => setChecked(true));
  }, []);

  if (!checked || !hasNews) return null;

  return (
    <section className="my-5 portal-news-section">
      <h2 style={{ fontSize: 24, fontWeight: 700, color: '#111827', marginBottom: 20 }}>
        Новини порталу
      </h2>
      <NewsPublic scope="portal" />
    </section>
  );
};

export default PortalNewsSection;